export default "__VITE_ASSET__DwWRY8XF__"